import Vue from 'vue'
import VueI18n from 'vue-i18n'

import deLang from './de.js'
import enLang from './en.js'

Vue.use(VueI18n)

const langs = {
	en: enLang,
	de: deLang,
}

const i18n = new VueI18n({
	locale: 'en', // set locale
	// locale: 'de', // set locale
	messages: { ...langs },
	fallbackLocale: 'en',
})

export default i18n
